/**
 * DeletedUserTableHeader - Header row for deleted users table
 */
import React from 'react';
import { TableHeaderCell, StaticHeaderCell } from './TableHeaderCell';

export function DeletedUserTableHeader({ getSortIcon, handleSort, tableId }) {
  return (
    <thead className="bg-gray-50 dark:bg-gray-800/50">
      <tr>
        <TableHeaderCell
          label="Name"
          sortKey="displayName"
          tooltipContent="User's display name and email address"
          tooltipId={`name-tooltip-${tableId}`}
          handleSort={handleSort}
          getSortIcon={getSortIcon}
        />
        <TableHeaderCell
          label="Email"
          sortKey="email"
          tooltipContent="User's email address"
          tooltipId={`email-tooltip-${tableId}`}
          handleSort={handleSort}
          getSortIcon={getSortIcon}
        />
        <TableHeaderCell
          label="Plan Level"
          sortKey="planLevel"
          tooltipContent="User's subscription plan when deleted"
          tooltipId={`plan-tooltip-${tableId}`}
          handleSort={handleSort}
          getSortIcon={getSortIcon}
          align="center"
        />
        <TableHeaderCell
          label="Paid Customer"
          sortKey="totalRevenue"
          tooltipContent="Whether the user actually paid money (not just trial users)"
          tooltipId={`paid-tooltip-${tableId}`}
          handleSort={handleSort}
          getSortIcon={getSortIcon}
          align="center"
        />
        <TableHeaderCell
          label="Account Created"
          sortKey="accountCreatedAt"
          tooltipContent="When the account was created"
          tooltipId={`created-tooltip-${tableId}`}
          handleSort={handleSort}
          getSortIcon={getSortIcon}
          align="center"
        />
        <TableHeaderCell
          label="Deleted At"
          sortKey="deletedAt"
          tooltipContent="When the account was deleted"
          tooltipId={`deleted-tooltip-${tableId}`}
          handleSort={handleSort}
          getSortIcon={getSortIcon}
          align="center"
        />
        <TableHeaderCell
          label="Engagement"
          sortKey="currentStreak"
          tooltipContent="Current streak (consecutive active days) and active days this month"
          tooltipId={`engagement-tooltip-${tableId}`}
          handleSort={handleSort}
          getSortIcon={getSortIcon}
          align="center"
        />
        <TableHeaderCell
          label="Templates"
          sortKey="totalTemplatesEdited"
          tooltipContent="Regular templates edited"
          tooltipId={`templates-tooltip-${tableId}`}
          handleSort={handleSort}
          getSortIcon={getSortIcon}
          align="center"
        />
        <TableHeaderCell
          label="Video Templates"
          sortKey="totalVideoTemplatesEdited"
          tooltipContent="Video templates edited"
          tooltipId={`video-templates-tooltip-${tableId}`}
          handleSort={handleSort}
          getSortIcon={getSortIcon}
          align="center"
        />
        <TableHeaderCell
          label="Stock Videos"
          sortKey="totalStockVideosDownloaded"
          tooltipContent="Stock videos downloaded"
          tooltipId={`stock-videos-tooltip-${tableId}`}
          handleSort={handleSort}
          getSortIcon={getSortIcon}
          align="center"
        />
        <TableHeaderCell
          label="Campaigns"
          sortKey="campaignsCreated"
          tooltipContent="Campaigns created"
          tooltipId={`campaigns-tooltip-${tableId}`}
          handleSort={handleSort}
          getSortIcon={getSortIcon}
          align="center"
        />
        <TableHeaderCell
          label="Survey Videos"
          sortKey="surveyVideosCollected"
          tooltipContent="Survey videos collected"
          tooltipId={`survey-videos-tooltip-${tableId}`}
          handleSort={handleSort}
          getSortIcon={getSortIcon}
          align="center"
        />
        <TableHeaderCell
          label="Sub Status"
          sortKey="subscriptionStatus"
          tooltipContent="Subscription status when deleted"
          tooltipId={`sub-tooltip-${tableId}`}
          handleSort={handleSort}
          getSortIcon={getSortIcon}
          align="center"
        />
        <TableHeaderCell
          label="Last Active"
          sortKey="lastActive"
          tooltipContent="When the user was last active on the platform"
          tooltipId={`last-active-tooltip-${tableId}`}
          handleSort={handleSort}
          getSortIcon={getSortIcon}
          align="center"
        />
        <TableHeaderCell
          label="Email Verified"
          sortKey="isEmailVerified"
          tooltipContent="Whether the user's email was verified"
          tooltipId={`email-verified-tooltip-${tableId}`}
          handleSort={handleSort}
          getSortIcon={getSortIcon}
          align="center"
        />
        <TableHeaderCell
          label="Primary Reason"
          sortKey="exitSurveyData.primaryReason"
          tooltipContent="Main reason for account deletion"
          tooltipId={`primary-reason-tooltip-${tableId}`}
          handleSort={handleSort}
          getSortIcon={getSortIcon}
          align="center"
        />
        <TableHeaderCell
          label="Secondary Reason"
          sortKey="exitSurveyData.secondaryReason"
          tooltipContent="Additional reason for deletion"
          tooltipId={`secondary-reason-tooltip-${tableId}`}
          handleSort={handleSort}
          getSortIcon={getSortIcon}
          align="center"
        />
        <th 
          className="px-6 py-3 text-center text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700/50 select-none w-80 min-w-80"
          onClick={() => handleSort('exitSurveyData.feedback')}
        >
          <div className="flex items-center justify-center space-x-1">
            <span>Feedback</span>
            {getSortIcon('exitSurveyData.feedback')}
          </div>
        </th>
        <TableHeaderCell
          label="Source"
          sortKey="deletionSource"
          tooltipContent="Self-deletion or admin deletion"
          tooltipId={`source-tooltip-${tableId}`}
          handleSort={handleSort}
          getSortIcon={getSortIcon}
          align="center"
        />
        <StaticHeaderCell
          label="Actions"
          tooltipContent="Remove deleted user record from admin dashboard"
          tooltipId={`actions-tooltip-${tableId}`}
          align="center"
        />
      </tr>
    </thead>
  );
}

